import slide1 from '../images/slides/slide1.jpg'
import slide2 from '../images/slides/slide2.jpg'
import slide3 from '../images/slides/slide3.jpg'
import slide4 from '../images/slides/slide4.jpg'
import slide5 from '../images/slides/slide5.jpg'
import slide6 from '../images/slides/slide6.jpg'
import slide7 from '../images/slides/slide7.jpg'
import slide8 from '../images/slides/slide8.jpg'
import slide9 from '../images/slides/slide9.jpg'
import slide10 from '../images/slides/slide10.jpg'
import slide11 from '../images/slides/slide11.jpg'
import slide12 from '../images/slides/slide12.jpg'
import slide13 from '../images/slides/slide13.jpg'
import slide14 from '../images/slides/slide14.jpg'
import slide15 from '../images/slides/slide15.jpg'


export const slidesList = [
    { image: slide1 },
    { image: slide2 },
    { image: slide3 },
    { image: slide4 },
    { image: slide5 },
    { image: slide6 },
    { image: slide7 },
    { image: slide8 },
    { image: slide9 },
    { image: slide10 },
    { image: slide11 },
    { image: slide12 },
    { image: slide13 },
    { image: slide14 },
    { image: slide15 }
];